import { Route, Routes } from "react-router-dom";
import LoginPage from "../LoginPage";
import SizeCalculators from "../SizeCalculatorsPage";
import ResetPasswordPage from "../MobileApp/ResetPasswordPage";

export const UnAuthenticatedRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/sizes" element={<SizeCalculators />} />
    </Routes>
  );
};
